import React, { useState } from "react";
import styles from "./FixErrors.module.css";
import { Breadcrumb } from "../../Utils/helper";
import { Link, useLocation, useNavigate } from "react-router-dom";
const FixErrors = () => {
  const location=useLocation();
  const [isTrue, setTrue] = useState(false);
  const handleDownlaod = () => {
    setTrue(!isTrue);
  };
  const FixUser = [
    { id: 1, 
      name: "Abc Consultant Pvt Limited", 
      email: "Abc@test.com" 
    },

    { id: 2, 
      name: "Bac Pvt Limited", 
      email: "Bac@test.com" 
    }
  ];
  const navigate = useNavigate();
  const handleUpload = () => {
    navigate("/Bulkupload");
  };
  if(location.pathname.includes('/Bulkupload/Fixerrors'))
  var headerPos = 5;
  
  return (
    <>
      <div className={styles.companyProfile}>
        <Breadcrumb />
        <div className={styles.companyHeader}>
          <main className={styles.frameSupportingText}>
            <section className={styles.h1Parent}>
              <div className={styles.heading}>
                <div className={styles.heading}>
                  <div className={styles.button} onClick={() => navigate(-1)}>
                    <img
                      className={styles.arrowLeftIcon}
                      loading="eager"
                      alt=""
                      src="/arrowleft.svg"
                    />
                  </div>
                  <div className={styles.text}>
                    <h2 className={styles.navitem}>Fix Errors</h2>
                  </div>
                  {isTrue ? (
                    <span
                      style={{
                        color: "green",
                        padding: "10px",
                        borderRadius: "7px",
                      }}
                    >
                      Downloading Start.......
                    </span>
                  ) : (
                    ""
                  )}
                  <div classname={styles.optionsBtn}>
                    <div className={styles.Option}>
                      <div
                        className={styles.btn1}
                        onClick={() => handleUpload()}
                      >
                        Upload Again
                      </div>
                      <div
                        className={styles.btn2}
                        onClick={() => alert("Submitted")}
                      >
                        <div style={{ fontWeight: "600" }}>Submit</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </main>
        </div>
        <div className={styles.tableHeader}>
          <div className={styles.inputField2}>
            <div className={styles.input1}>
              <div className={styles.content1}>
                <img
                  className={styles.searchOutlineIcon1}
                  alt=""
                  src="/searchoutline.svg"
                />
                <input className={styles.inputText1} placeholder="Search" />
              </div>
            </div>
          </div>
          <div className={styles.buttons1}>
            <Link style={{ textDecoration: "none" }}>
              <div className={styles.button4}>
                <img
                  className={styles.downloadOutlineIcon}
                  alt=""
                  src="/downloadoutline.svg"
                />
                <div
                  className={styles.buttonText}
                  onClick={() => handleDownlaod()}
                >
                  Download as CSV
                </div>
              </div>
            </Link>
          </div>
        </div>
        <div className={styles.mainTable}>
          <div className={styles.tableContent}>
            <div className={styles.tableContainer}>
              <div className={styles.tableRow1}>
                <div className={styles.heading1}>COMPANY NAME</div>
                <div className={styles.heading1}>USER EMAIL</div>
                <div className={styles.heading1}>USER TYPER</div>
              </div>

              <div className={styles.tableRow}>
                <div className={styles.cell}>
                  {FixUser.map((i, index) => (
                    <div className={styles.inputContainer} key={index}>
                      <input
                        type="text"
                        placeholder={i.name}
                      />
                    </div>
                  ))}
                </div>

                <div className={styles.cell}>
                  {FixUser.map((i, index) => (
                    <div className={styles.inputContainer1} key={index}>
                      <input type="text" placeholder={i.email} />
                    </div>
                  ))}
                </div>
                <div className={styles.cell}>
                  {FixUser.map((i, index) => (
                    <div className={styles.inputContainer2} key={index}>
                      <div className={styles.inputBox}>
                        <div className="chosen-wrapper" data-js="custom-scroll">
                          <select>
                            <option value="">Select user type</option>
                            <option value="1">Issuer</option>
                            <option>Verifier</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FixErrors;
